<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-py-xs" v-if="!insideModal">
            <technical-assesment-page-header v-bind="headerData" />
            <div>
              <div class="buttons-report">
                <span class="commercial-datail departament-detail">
                  {{ $gettext("COMMERCIAL").toUpperCase() }}
                </span>
                <q-btn color="primary" icon="mdi-eye" @click="() => showModalAnnexTable = true"
                  :disable="annexReportComposition.length == 0">
                  Visualizar Laudo ({{ annexReportComposition.length }})
                </q-btn>
                <q-btn v-if="!isLaboratoryChange" color="primary" icon="mdi-attachment"
                  :label="$gettext('ANNEX_REPORT')" @click="() => showModalAddAnnex = true" />
              </div>
              <hr>
            </div>
          </q-card-section>
          <q-card-section class="q-px-md">
            <jt-dynamic-form v-if="!slots.form" ref="dynamicForm" :inputs="inputs" style="height:480px !important;"
              :relacionamentos="elements[0].relacionamentos" :model="elements[0].dadosForm"
              :interface="elements[0].nmInterface" form-class="form dynamic"
              @composition-button-click="actionButtonComposition" @input="onInputChange"
              @composition-modal-close="compositionModalCloseHandler" @search-found="searchFound"
              @on-select-change="onSelectChange" @on-select-ajax="(d) => { $emit('on-select-ajax', d) }" />
            <div v-if="isLaboratoryChange || isCommercialChange">
              <span class="departament-detail">
                <translate>RESDIUE_ANALISY</translate>
              </span>
              <hr>
              <q-form>
                <div class="form-laboratory">
                  <div class="row">
                    <q-input :disable="isCommercialChange" class="col-2 q-px-sm q-mt-md" v-model="labFormModel.valuePh"
                      outlined :label="$gettext('PH')" mask="####.##" reverse-fill-mask >
                      <template v-slot:append>
                        <p class="testeee" :style="{color : inputColor}" >{{$gettext('PH')}}-{{ phValue }} </p>
                      </template>
                    </q-input>
                    <q-input :disable="isCommercialChange" class="col-2 q-px-sm q-mt-md" outlined
                      :label="$gettext('TEMPERATURE')" v-model="labFormModel.temperature" mask="####.##"
                      reverse-fill-mask />
                    <q-input :disable="isCommercialChange" class="col-2 q-px-sm q-mt-md" outlined
                      :label="$gettext('RADIOACTIVITY')" v-model="labFormModel.radioactivity" mask="####.##"
                      reverse-fill-mask />
                      <q-select emit-value map-options outlined v-model="labFormModel.freeLiquids" :disable="isCommercialChange"
                      :options="combosOptionsTrueFalse" :label="$gettext('FREE_LIQUIDS')"
                      class="col-3 q-px-sm q-mt-md" />
                    <q-select emit-value map-options outlined v-model="labFormModel.oilsGreases" :disable="isCommercialChange"
                      :options="combosOptionsTrueFalse" :label="$gettext('OILS_GREASES')"
                      class="col-3 q-px-sm q-mt-md" />
                  </div>
                  <div class="row">
                    <div class="col-2 q-px-sm q-mt-md"> </div>
                    <div class="col-2 q-px-sm q-mt-md"> </div>
                    <div class="col-2 q-px-sm q-mt-md"> </div>
                      <q-input class="col-3 q-px-sm q-mt-md" outlined :label="$gettext('FREE_LIQUIDS_VALUE')"
                      v-model="labFormModel.freeLiquidsDescription"
                      :disable="isCommercialChange" mask="####.##" reverse-fill-mask />
                      <q-input class="col-3 q-px-sm q-mt-md" outlined :label="$gettext('OILS_GREASES_VALUE')"
                      v-model="labFormModel.oilsGreasesDescription"
                      :disable="isCommercialChange" mask="####.##" reverse-fill-mask />
                  </div>
                  <div class="laboratory-visual">
                    <p class="departament-detail">
                      <translate>REATIVITY</translate>
                    </p>
                    <hr>
                    <div class="row">
                      <q-select emit-value map-options outlined v-model="labFormModel.reativityWater"
                        :options="combosOptionsTrueFalse" :label="$gettext('WATER_REATIVITY')"
                        class="col-3 q-px-sm q-mt-md" :disable="isCommercialChange" />
                      <q-select emit-value map-options outlined v-model="labFormModel.reativityAcid"
                        :options="combosOptionsTrueFalse" :label="$gettext('ACID_REATIVITY')"
                        class="col-3 q-px-sm q-mt-md" :disable="isCommercialChange" />
                      <q-select emit-value map-options outlined v-model="labFormModel.reativityBase"
                        :options="combosOptionsTrueFalse" :label="$gettext('BASE_REATIVITY')"
                        class="col-3 q-px-sm q-mt-md" :disable="isCommercialChange" />
                    </div>
                  </div>
                  <div class="laboratory-visual">
                    <p class="departament-detail">
                      <translate>VISUAL</translate>
                    </p>
                    <hr>
                    <div class="row">
                      <q-input :disable="isCommercialChange" class="col-3 q-px-sm q-mt-md " outlined
                        :label="$gettext('COLORATION')" v-model="labFormModel.color" />
                      <q-select emit-value map-options outlined v-model="labFormModel.smell" :disable="isCommercialChange"
                        :options="combosOptionsTrueFalse" :label="$gettext('SMELL')" class="col-3 q-px-sm q-mt-md" />
                      <q-select emit-value map-options outlined v-model="labFormModel.aspectType" :disable="isCommercialChange"
                        :options="comboOptionsAspectType" :label="$gettext('ASPECTY')" class="col-3 q-px-sm q-mt-md" />
                      <q-input :disable="isCommercialChange" class="col-3 q-px-sm q-mt-md " outlined
                        :label="$gettext('ASPECTY_DESCRIPTION')" v-model="labFormModel.aspectTypeDescription" />
                    </div>
                    <div class="row">
                      <q-input :disable="isCommercialChange" data-testid="laboratoryObservation" class="col-12 q-px-sm q-mt-md " outlined
                        :label="$gettext('OBSERVATION')" v-model="labFormModel.observation" />
                    </div>
                  </div>
                </div>
              </q-form>
            </div>

          </q-card-section>

        </q-card>
        <div v-if="forms[0] && forms[0].buttons.length > 0"
          class="row full-width q-col-gutter-lg justify-center q-py-md">
          <div class="col-lg-2 col-md-3" v-if="!isSave">
            <q-btn class="full-width" color="grey-7" @click="limparForm">
              <translate>CLEAN</translate>
            </q-btn>
          </div>
          <div v-for="(button, i) in forms[0].buttons" :key="i"
            :class="`col-lg-2 col-md-3 button-${button.name ? button.name.toLowerCase() : button.name}`">
            <q-btn :class="`full-width button-btn-${button.name ? button.name.toLowerCase() : button.name}`"
              color="info" @click="save">
              <q-icon v-if="button.icon" :name="button.icon" size="18px" class="position-icon-filter" />
              {{ button.label }}
            </q-btn>
          </div>
        </div>
        <div v-else class="row full-width q-col-gutter-lg justify-center q-py-md">
          <div class="col-lg-2 col-md-3">
            <q-btn class="full-width" color="negative" @click="openDialogConfirmation('reproveLaboratory')">
              <translate>REPROVED</translate>
            </q-btn>
          </div>
          <div class="col-lg-2 col-md-3">
            <q-btn class="full-width" color="grey-7" @click="openDialogConfirmation('commercialReturn')">
              <translate>RETURN_COMMERCIAL</translate>
            </q-btn>
          </div>
          <div class="col-lg-2 col-md-3">
            <q-btn class="full-width" color="positive" @click="openDialogConfirmation('approveLaboratory')">
              <translate>APPROVED</translate>
            </q-btn>
          </div>
        </div>
      </div>
    </div>
    <annex-report ref="annexReport" :show="showModalAddAnnex" @input="(open) => (showModalAddAnnex = open)" @save="addNewAnnexReport"
      :isCommercialChange="isCommercialChange" />
    <annex-report-table :show="showModalAnnexTable" @input="(open) => (showModalAnnexTable = open)"
      :rows="annexReportComposition" :deleteRow="isCommercialChange || !isSave" />
    <confirmation-dialog :show="showConfirmationDialog" :parentCaller="parentCaller" @yes-button="handleYesButtonClick"
      :message="confimationDialogMessage" :color="color" @input="(show) => {
        showConfirmationDialog = show
        parentCaller = ''
      }" />
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm } from 'jtech-webcomps'
import { repository, messageBox } from 'jtech'
import TechnicalAssesmentPageHeader from './TechnicalAssesmentPageHeader.vue'
import AnnexReport from './AnnexReport.vue'
import moment from 'moment'
import AnnexReportTable from './AnnexReportTable.vue'
import uploadFileRequest from 'src/jtech/controllers-base-request/uploadFileRequest.js'
import techinicalAssementRepository from './TechinicalAssementRepository.js'
import eventCommunicationHandle from './CommunicationState.js'
import ConfirmationDialog from './ConfirmationDialog.vue'
const { page } = JtCrud

@Component({
  mixins: [page],
  name: 'TechnicalAssessmentPage',
  components: { JtDynamicForm, page, TechnicalAssesmentPageHeader, AnnexReport, AnnexReportTable, ConfirmationDialog },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
class TechnicalAssessmentPage extends Vue {
  combosOptionsTrueFalse = [{ label: this.$gettext('ABSENT'), value: false }, { label: this.$gettext('PRESENT'), value: true }]
  comboOptionsAspectType = [
    { label: this.$gettext('DOUGH'), value: 20230001 },
    { label: this.$gettext('LIGHT_AND_BULKY'), value: 20230005 },
    { label: this.$gettext('SANDY'), value: 20230002 },
    { label: this.$gettext('SOLID'), value: 20230003 },
    { label: this.$gettext('GRANULATED'), value: 20230004 },
    { label: this.$gettext('OTHERS'), value: 20230006 }
  ]

  phValue = ''
  inputColor = 'grey'

  @Watch('labFormModel.valuePh')
  getPhValue (newValue) {
    if (!newValue) {
      this.inputColor = 'grey'
      this.phValue = ''
      return
    }
    if (+newValue < 2) {
      this.inputColor = 'red'
      this.phValue = 'Baixo'
      return
    }
    if (+newValue > 12.5) {
      this.inputColor = 'red'
      this.phValue = 'Alto'
      return
    }
    this.phValue = 'Ok'
    this.inputColor = 'green'
  }

  get isSave () {
    return !!this.elements[0].dadosForm?.id
  }

  showModalAddAnnex = false
  showModalAnnexTable = false
  showConfirmationDialog = false
  landfillLaboratoryProcedure = ''
  annexReportComposition = []
  isLaboratoryChange = false
  isCommercialChange = false
  labId = ''
  parentCaller = ''
  confimationDialogMessage = ''
  color = 'positive'

  labFormModel = {
    reativityWater: false,
    freeLiquids: false,
    reativityAcid: false,
    oilsGreases: false,
    reativityBase: false,
    smell: false,
    aspectType: 20230006,
    returnToCommercial: null,
    valuePh: null
  }

  handleYesButtonClick (param) {
    if (param === 'reproveLaboratory') {
      this.showConfirmationDialog = false
      this.saveLaboratory(false)
    } else if (param === 'approveLaboratory') {
      this.showConfirmationDialog = false
      this.saveLaboratory(true)
    } else if (param === 'commercialReturn') {
      this.showConfirmationDialog = false
      this.returnToCommercial()
    }
  }

  openDialogConfirmation (param) {
    if (param === 'reproveLaboratory') {
      this.confimationDialogMessage = `${this.$gettext('DO_YOU_WISH_REPROVE_ANALISY')} ${this.headerData.processNumber} ? `
      this.color = 'negative'
    } else if (param === 'approveLaboratory') {
      this.color = 'positive'
      this.confimationDialogMessage = `${this.$gettext('DO_YOU_WISH_APPROVED_ANALISY')} ${this.headerData.processNumber} ?`
    } else if (param === 'commercialReturn') {
      this.color = 'positive'
      this.confimationDialogMessage = `${this.$gettext('DO_YOU_WISH_RETURN_TO_COMMERCIAL')} ${this.headerData.processNumber} ?`
    }
    this.parentCaller = param
    this.showConfirmationDialog = true
  }

  async returnToCommercial () {
    this.labFormModel.returnToCommercial = true
    if (this.isUpdate()) {
      delete this.labFormModel.id
      delete this.labFormModel.userLab
      await techinicalAssementRepository.updateTechnicalLaboratory(this.labFormModel, this.elements[0]?.dadosForm?.laboratyId)
    } else {
      await techinicalAssementRepository.saveTechnicalLaboratory(this.labFormModel)
    }
    this.saveMessage()
    this.closePage()
  }

  userLab = ''

  onInputChange (inputs) {
    this.setGeneratorInfosWhenNull(inputs)
    this.setClientInfosWhenNull(inputs)
  }

  setClientInfosWhenNull (inputs) {
    if (!inputs.possibleClient_document) {
      this.$nextTick(() => {
        this.$set(this.elements[0].dadosForm, 'possibleClient_name', null)
        this.$set(this.elements[0].dadosForm, 'addresPerson', null)
        this.$set(this.elements[0].dadosForm, 'possibleClient', null)
      })
    }
  }

  setGeneratorInfosWhenNull (inputs) {
    if (!inputs.possibleGenerator_document) {
      this.$nextTick(() => {
        this.$set(this.elements[0].dadosForm, 'possibleGenerator_name', null)
        this.$set(this.elements[0].dadosForm, 'activityArea', null)
        this.$set(this.elements[0].dadosForm, 'possibleGenerator', null)
      })
    }
  }

  closePage () {
    eventCommunicationHandle.$emit('close-page', this)
  }

  beforeDestroy () {
    eventCommunicationHandle.$emit('page-params', null)
  }

  approvedLaboratorySave () {
    this.saveLaboratory(true)
  }

  reproveLaboratorySave () {
    this.saveLaboratory(false)
  }

  async saveLaboratory (approved) {
    if (this.labFormModel.id) {
      this.labId = this.deepCloneLabId()
    }
    this.labFormModel.approved = approved
    delete this.labFormModel.id
    delete this.labFormModel.userLab
    if (!this.labId) {
      await techinicalAssementRepository.saveTechnicalLaboratory(this.labFormModel)
    } else {
      await techinicalAssementRepository.updateTechnicalLaboratory(this.labFormModel, this.elements[0]?.dadosForm?.laboratyId)
    }
    this.saveMessage()
    this.closePage()
  }

  headerData = {
    id: 1,
    code: '',
    procedureRevision: '',
    processNumber: '',
    technicalRevision: 1,
    createdAt: moment().format('DD/MM/YYYY')
  }

  deepCloneLabId () {
    return JSON.parse(JSON.stringify(this.labFormModel.id))
  }

  isUpdate () {
    return this.elements[0]?.dadosForm?.laboratyId
  }

  async mounted () {
    this.isLaboratoryChange = !!this.elements[0]?.isLaboratory
    this.isCommercialChange = !!this.elements[0]?.isCommercialChange
    this.hasAnnexReportData()
    this.getBasicInfoToComponenteHeader()
    await this.setLaboratoryDataInputs()
  }

  async setLaboratoryDataInputs () {
    let userContext = ''
    if (this.isLaboratoryChange || this.isCommercialChange) {
      const {
        landfillLaboratoryCode, _landfillLaboratoryProcedure, landfillLaboratoryRevision, createdDate, revision, processYear, processNumber, userLab, technicalAssesmentResidueCommercialId
      } = this.elements[0].dadosForm
      userContext = userLab
      this.labFormModel.technicalAssesmentResidueCommercialId = technicalAssesmentResidueCommercialId
      this.headerData.code = landfillLaboratoryCode
      this.headerData.procedureRevision = landfillLaboratoryRevision
      this.headerData.createdAt = moment(createdDate).format('DD/MM/YYYY')
      this.headerData.technicalRevision = revision
      this.headerData.processNumber = `${processNumber}/${processYear}`
      this.landfillLaboratoryProcedure = _landfillLaboratoryProcedure
      this.userLab = userContext
    }
    if ((this.isCommercialChange || this.isLaboratoryChange) && this.elements[0].dadosForm?.laboratyId) {
      const { data } = await techinicalAssementRepository.findTechnicalLaboratory(this.elements[0].dadosForm.laboratyId)
      this.labFormModel = data
      this.formatDecimalInputs()
      if (this.isLaboratoryChange) {
        this.userLab = userContext
      } else {
        this.userLab = data.userLab
      }
    }
    if (this.landfillLaboratoryProcedure) eventCommunicationHandle.$emit('page-params', this.landfillLaboratoryProcedure)
  }

  formatDecimalInputs () {
    this.labFormModel.freeLiquidsDescription = this.formatNumberToDecimal(this.labFormModel.freeLiquidsDescription)
    this.labFormModel.temperature = this.formatNumberToDecimal(this.labFormModel.temperature)
    this.labFormModel.oilsGreasesDescription = this.formatNumberToDecimal(this.labFormModel.oilsGreasesDescription)
    this.labFormModel.valuePh = this.formatNumberToDecimal(this.labFormModel.valuePh)
    this.labFormModel.radioactivity = this.formatNumberToDecimal(this.labFormModel.radioactivity)
  }

  formatNumberToDecimal (number) {
    if (number) {
      return Number.parseFloat(number).toFixed(2)
    }
  }

  getBasicInfoToComponenteHeader () {
    if (this.elements[0].dadosForm?.landfillLaboratoryProcedure && this.elements[0].dadosForm?.code && this.elements[0].dadosForm?.procedureRevision && !this.isLaboratoryChange) {
      this.headerData.code = this.elements[0].dadosForm?.landfillLaboratoryProcedure && this.elements[0].dadosForm?.code
      this.headerData.procedureRevision = this.elements[0].dadosForm?.code && this.elements[0].dadosForm?.procedureRevision
    }
  }

  hasAnnexReportData () {
    this.elements[0].dadosForm?.annexReports.length ? this.annexReportComposition = this.elements[0].dadosForm?.annexReports : this.$attrsannexReportComposition = []
  }

  async save (button) {
    if (this.isValidForm()) {
      if (!this.getParams().landfillLaboratoryProcedure) {
        messageBox.warn(this.$gettext('SELECT_A_VALID_LANDFILL_THAT_CONTAINS_A_VALID_PROCEDURE').toUpperCase())
        throw 'this.elements[0].dadosForm?.landfillLaboratoryProcedure is \'undefinied\''
      }
      if (this.isCommercialChange) {
        const data = [
          { object: this.transformDataToBlob(this.getParams()) },
          ...this.annexReportComposition.filter(f => f.new).map(an => ({ files: an.file }))
        ]
        await uploadFileRequest.uploadFile(`technicalAssessmentsResiduesComercial/${this.elements[0].dadosForm.id}`, data)
        this.saveMessage()
        this.closePage()
        return
      }

      const data = [
        { object: this.transformDataToBlob(this.getParams()) },
        ...this.annexReportComposition.map(an => ({ files: an.file }))
      ]
      await uploadFileRequest.uploadFile('technicalAssessmentsResiduesComercial', data)
      this.limparForm()
      this.saveMessage()
    } else {
      this.$emit('show-message', 'warning', 'REQUIRED_FIELDS_NOT_FILLED', this)
    }
  }

  saveMessage () {
    messageBox.success(this.$gettext('REGISTER_SAVE_WITH_SUCCESSFULL'), 'top-right')
  }

  transformDataToBlob (data) {
    const json = JSON.stringify(data)
    return new Blob([json], {
      type: 'application/json'
    })
  }

  async addNewAnnexReport (annexReport) {
    annexReport.fileName = annexReport.file.name
    const nameAlreadyExist = !!this.elements[0].dadosForm.annexReports.find(e => e.fileName === annexReport.fileName)
    if (nameAlreadyExist) {
      messageBox.warn(this.$gettext('ALREADY_EXIST_A_DOCUMENT_WITH') + annexReport.fileName)
      return
    }
    this.annexReportComposition.push(annexReport)
    this.$nextTick(() => {
      this.$set(this.elements[0].dadosForm, 'annexReports', this.annexReportComposition)
    })
    this.$refs.annexReport.hide()
  }

  limparForm () {
    if (this.slots.form) {
      const children = this._slotElem(this.$children, 'resetForm')
      if (children) children.resetForm()
      this.$emit('form-reset', { form: children, page: this })
    } else {
      Array.isArray(this.$refs.dynamicForm)
        ? this.$refs.dynamicForm[0].resetForm()
        : this.$refs.dynamicForm.resetForm()
      this.$emit('form-reset', { form: this.$refs.dynamicForm, page: this })
    }
    this.$nextTick(() => {
      this.$set(this.elements[0].dadosForm, 'possibleGenerator_name', '')
      this.$set(this.elements[0].dadosForm, 'activityArea', '')
      this.$set(this.elements[0].dadosForm, 'possibleGenerator', '')
      this.$set(this.elements[0].dadosForm, 'possibleClient_name', '')
      this.$set(this.elements[0].dadosForm, 'addresPerson', '')
      this.$set(this.elements[0].dadosForm, 'possibleClient', '')
      this.$set(this.elements[0].dadosForm, 'landfillLaboratoryProcedure', undefined)
      this.$set(this.elements[0].dadosForm, 'code', undefined)
      this.$set(this.elements[0].dadosForm, 'procedureRevision', undefined)
      this.$set(this.elements[0].dadosForm, 'hasSample', false)
      this.$set(this.elements[0].dadosForm, 'annexReports', [])
      this.headerData.landfillLaboratoryProcedure = undefined
      this.headerData.code = undefined
      this.headerData.procedureRevision = undefined
      this.headerData.createdAt = moment().format('DD/MM/YYYY')
      this.annexReportComposition = []
    })
  }

  async onSelectChange (input) {
    try {
      if (input.input.name === 'technicalAssessmentResidue_landfill') {
        const search = await repository.resolveLogic('landfillLaboratoryProcedure.findLandfillProcedureAvailableByLandfill', { id: input.selectedValue })
        this.$nextTick(() => {
          this.$set(this.elements[0].dadosForm, 'landfillLaboratoryProcedure', search.id)
          this.$set(this.elements[0].dadosForm, 'code', search.code)
          this.$set(this.elements[0].dadosForm, 'procedureRevision', search.revision)
        })
        this.headerData.code = search.code
        this.headerData.procedureRevision = search.revision
        this.headerData.technicalRevision = 1
      }
    } catch (error) {
      this.$nextTick(() => {
        this.$set(this.elements[0].dadosForm, 'landfillLaboratoryProcedure', undefined)
        this.$set(this.elements[0].dadosForm, 'code', undefined)
        this.$set(this.elements[0].dadosForm, 'procedureRevision', undefined)
        this.$set(this.elements[0].dadosForm, 'technicalAssessmentResidue_landfill', undefined)
      })
      this.headerData.code = ''
      this.headerData.procedureRevision = ''
      this.headerData.technicalRevision = 1
    }
  }

  changeInputTypeToPageSearch (inputName, type) {
    this.elements[0].inputs.find(
      (input) => (input.model == inputName)
    ).type = type
  }

  async searchFound (data) {
    this.setPersonNameAndAddres(data)
    this.setGeneratorNameAndActivityArea(data)
  }

  async setPersonNameAndAddres (data) {
    const id = data.possibleClient_document?.idField
    if (id) {
      const search = await repository.resolveLogic(
        'technicalAssessmentResidueCommercial.getFirstPhisicalAddresAndClientName', { id: id }
      )
      if ('possibleClient_document' in data) {
        this.$nextTick(() => {
          this.$set(this.elements[0].dadosForm, 'possibleClient_name', search.clientName)
          this.$set(this.elements[0].dadosForm, 'addresPerson', search.address)
          this.$set(this.elements[0].dadosForm, 'possibleClient', id)
        })
      }
    }
  }

  async setGeneratorNameAndActivityArea (data) {
    const id = data.possibleGenerator_document?.idField
    if (id) {
      const search = await repository.resolveLogic(
        'technicalAssessmentResidueCommercial.getFirstPhisicalAddresAndClientName', { id: id }
      )
      if ('possibleGenerator_document' in data) {
        this.$nextTick(() => {
          this.$set(this.elements[0].dadosForm, 'possibleGenerator_name', search.clientName)
          this.$set(this.elements[0].dadosForm, 'activityArea', search.activityArea)
          this.$set(this.elements[0].dadosForm, 'possibleGenerator', id)
        })
      }
    }
  }

  get inputs () {
    this.changeInputTypeToPageSearch('possibleClient_document', 'person_search')
    this.changeInputTypeToPageSearch('possibleGenerator_document', 'person_search')
    this.changeInputTypeToPageSearch('wasteCertified', 'cadri_search')
    return this.elements[0]?.inputs
  }
}
export default TechnicalAssessmentPage
</script>
<style lang="stylus" scoped>

.testeee{
  font-size: 14px !important;
}

hr {
    background-color: rgba(128, 128, 128, 0.1);
    border-color: rgba(128, 128, 128, 0.1);
}

.buttons-report {
    display: flex;
    gap 10px;
    flex-direction: row-reverse;
    position:relative;
}
.commercial-datail {
    position: absolute;
    left:2px;
    top: 18px
}

.departament-detail {
  font-weight:600;
  font-size:0.985em
}

strong {
  font-weight: 500;
  padding: 0 12px 0 0
}

.form-laboratory {
  height: 625px
}

.laboratory-visual {
  margin-top: 46px;
}

</style>
